import {HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Subject} from 'rxjs';

interface RequestState {
  request?: HttpRequest<any>;
  error?: any;
}

@Injectable()
export class RequestService {

  private readonly requestState$ = new Subject<RequestState | undefined>();
  private readonly responseErrorState$ = new Subject<any | undefined>();

  get requestStateStream$() {
    return this.requestState$.asObservable();
  }

  get requestErrorStateStream$() {
    return this.responseErrorState$.asObservable();
  }

  constructor() {
  }

  setError(error: any) {
    this.responseErrorState$.next(error);
    this.requestState$.next({error});
  }

  unsetError() {
    this.responseErrorState$.next(undefined);
  }

  setRequest(request: HttpRequest<any>) {
    this.requestState$.next({
      request,
    });
  }

  clearState() {
    this.unsetError();
    this.requestState$.next(undefined);
  }
}
